// Shared bits for the Documents (HR Policies) pages.
import { useEffect, useState } from 'react';
import { useApi } from '../../../lib/api';

// File types offered when uploading a document
export const DOCUMENT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.pptx,.txt,.csv,.png,.jpg,.jpeg';

const CATEGORY_COLORS = ['#06b6d4', '#4ad295', '#f0a93b', '#6f7bff', '#f472b6', '#34d399', '#fb923c', '#a78bfa'];

export function categoryColor(name = '') {
  const hash = name.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return CATEGORY_COLORS[hash % CATEGORY_COLORS.length];
}

// Short label for the document's format: Written, PDF, Word, Excel, …
export function documentKind(doc) {
  if (doc.doc_type !== 'file') return 'Written';
  const ext = (doc.file_name || '').split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'PDF';
  if (ext === 'doc' || ext === 'docx') return 'Word';
  if (ext === 'xls' || ext === 'xlsx' || ext === 'csv') return 'Excel';
  if (ext === 'pptx') return 'PowerPoint';
  if (['png', 'jpg', 'jpeg'].includes(ext)) return 'Image';
  return 'File';
}

// Shape AttachmentModal expects
export function documentAttachment(doc) {
  return { file_url: doc.file_url, file_name: doc.file_name, content_type: doc.content_type };
}

// Categories in display order. reload() after changes.
export function useDocumentCategories(appId) {
  const api = useApi();
  const [categories, setCategories] = useState([]);
  const [rev, setRev] = useState(0);
  useEffect(() => {
    api.documentCategories.list(appId)
      .then(r => setCategories(r.items || []))
      .catch(() => setCategories([]));
  }, [api, appId, rev]);
  return { categories, reload: () => setRev(r => r + 1) };
}

// Group documents by category in category order; unmatched ones go last.
export function groupByCategory(docs, categories) {
  const groups = categories.map(c => ({ id: c.id, name: c.name, docs: [] }));
  const byId = new Map(groups.map(g => [String(g.id), g]));
  const other = { id: 'none', name: 'Uncategorised', docs: [] };
  for (const d of docs) (byId.get(String(d.category_id)) || other).docs.push(d);
  return [...groups, other].filter(g => g.docs.length);
}
